export default __webpack_public_path__ + "static/media/right-fn.1b006ff3.png";